import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { Empty, Button } from 'antd'
import BasketsDuplicateHeader from './BasketsDuplicateTable/BasketsDuplicateHeader'
import BasketsDuplicateRow from './BasketsDuplicateTable/BasketsDuplicateRow'


// Nếu listData là raw baskets: gom nhóm theo number+location và chỉ giữ nhóm size>1
function normalizeToDupGroups(listData) {
    if (!Array.isArray(listData)) return []
    // detect if items are already groups (have docs array and maybe group_size)
    const looksLikeGroups = listData.length > 0 && listData[0] && Array.isArray(listData[0].docs)
    if (looksLikeGroups) {
        // keep only groups with more than 1 doc
        return listData
            .map(g => ({
                basket_number: g.basket_number ?? g.number ?? g.basket_number,
                basket_location: g.basket_location ?? g.location ?? g.basket_location,
                docs: g.docs ?? [],
                basket_total_items: g.basket_total_items ?? g.total_items ?? (g.docs && g.docs[0] && g.docs[0].total_items),
                count: g.count,
            }))
            .filter(g => Array.isArray(g.docs) && g.docs.length > 1)
    }

    // otherwise treat as raw basket objects (each has docs array)
    const rows = []
    listData.forEach(b => {
        const number = b.number
        const location = b.location
        const docs = Array.isArray(b.docs) ? b.docs : []
        if (docs.length === 0) return
        const key = `${number}||${location}`
        rows.push({ key, number, location, docs, total_items: b.total_items })
    })

    // group by key
    const groupsMap = new Map()
    rows.forEach(r => {
        const key = `${r.number}||${r.location}`
        if (!groupsMap.has(key)) groupsMap.set(key, { basket_number: r.number, basket_location: r.location, docs: [] })
        groupsMap.get(key).docs.push(...r.docs)
    })

    const groups = Array.from(groupsMap.values()).filter(g => g.docs.length > 1)
    return groups
}

function BasketsDuplicateTable(props) {
    const { listData = [], resetData } = props
    const [expandedKey, setExpandedKey] = useState(null)

    // normalized duplicate groups
    const dupGroups = useMemo(() => normalizeToDupGroups(listData), [listData])

    function toggleExpand(key) {
        setExpandedKey(prev => (prev === key ? null : key))
    }

    return (
        <div className="BasketsDuplicateTable">
            <table className="table ">
                <BasketsDuplicateHeader />
                <tbody>
                    {Array.isArray(dupGroups) && dupGroups.length > 0 ? (
                        dupGroups.map((group, idx) => {
                            const key = `${group.basket_number}||${group.basket_location}_${idx}`
                            const isExpanded = expandedKey === key
                            return (
                                <BasketsDuplicateRow
                                    key={key}
                                    group={group}
                                    expanded={isExpanded}
                                    onToggle={() => toggleExpand(key)}
                                    resetData={resetData}
                                />
                            )
                        })
                    ) : (
                        <tr>
                            <td colSpan={6} style={{ padding: 24 }}>
                                <Empty description="Không có dữ liệu" />
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    )
}

BasketsDuplicateTable.propTypes = {
    listData: PropTypes.array
}

export default BasketsDuplicateTable
